import { Controller } from '@hotwired/stimulus';

export default class DateFieldController extends Controller {
  open(event) {
    // Calendar icon is the element's ::after (not a child): clicking it targets the element and opens the picker,
    // whereas clicking the element's children (input, label) does not.
    if (event.target === this.element) {
      this.element.querySelector("input[type='date']").showPicker();
    }
  }
}
